import StrategyInfoPanel from './StrategyInfoPanel';

export default StrategyInfoPanel;
